import api from "./api";

export interface CreatePaymentResponse {
  paymentId: string;
  confirmationUrl: string;
}

export interface PaymentStatus {
  id: string;
  status: string;
  processed: boolean;
  amount: number;
  currency: string;
  description?: string;
  createdAt: string;
  updatedAt: string;
}

export interface PaymentHistoryResponse {
  data: PaymentStatus[];
}

export const createPayment = async (amount: number, description?: string): Promise<CreatePaymentResponse> => {
  const response = await api.post<CreatePaymentResponse>("/payments/create", { amount, description });
  return response.data;
};

export const getPaymentStatus = async (paymentId: string): Promise<PaymentStatus> => {
  const response = await api.get<PaymentStatus>(`/payments/${paymentId}`);
  return response.data;
};

export const listPayments = async (): Promise<PaymentHistoryResponse> => {
  const response = await api.get<PaymentHistoryResponse>('/payments');
  return response.data;
};
